<template>
  <b-modal id="changeAvatarModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.userdata.changeUserDataAvatarHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" v-if="avatarPreview">
        <div style="display:table;margin:0 auto;">
          <b-img :src="avatarPreview" alt="avatar" />
        </div>
      </b-col>
      <b-col>
        <b-form-file @change="onFileChange(avatar, $event)" name="avatar" accept=".jpg, .png, .gif" v-model="avatar" :state="Boolean(avatar)" :placeholder="$t('global.chooseImage')"></b-form-file>
        <b-input-group-append v-if="avatarPreview">
          <b-button variant="danger" v-b-tooltip.hover :title="$t('buttons.delete')" @click="deleteAvatar()">{{ $t('buttons.delete') }}</b-button>
        </b-input-group-append>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn @click="submitFile()">{{ $t('buttons.submit') }}</b-btn>
        <b-button class="btn btn-danger" @click="closeModal()">{{ $t('buttons.close') }}</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import getIdFromLink from '@/utils/getIdFromLink'

export default {
  name: 'ChangeAvatarModal',
  computed: {
    show () {
      return this.$store.state.modals.userdata.changeAvatar.show
    },
    userDataObject () {
      return this.$store.state.modals.userdata.changeAvatar.userData
    },
    close () {
      return this.$store.state.modals.userdata.changeAvatar.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'userDataObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      userData: null,
      avatar: '',
      avatarPreview: null
    }
  },
  methods: {
    deleteAvatar () {
      this.avatar = ''
      this.avatarPreview = null
    },
    onFileChange (item, e) {
      this.avatarDisplay = true
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createImage(item, files[0])
    },
    createImage (item, file) {
      var reader = new FileReader()

      reader.onload = (e) => {
        // this.data.avatar = this.data.avatarPreview
        // this.data.avatarPreview = ''
        this.avatarPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },
    openModal () {
      if (this.show === 1 && this.userDataObject) {
        this.userData = Object.assign({}, this.userDataObject)
        this.$store.state.modals.userdata.changeAvatar.show = 0
        this.$store.state.modals.userdata.changeAvatar.userData = null
        this.$bvModal.show('changeAvatarModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdata.changeAvatar.close = 0
      }
      this.$bvModal.hide('changeAvatarModal')
    },
    submitFile () {
      let formData = new FormData()
      formData.append('avatar', this.avatar)
      this.$http.post('api/user_datas/' + getIdFromLink(this.userData['@id']) + '/update_avatar',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$Swal({
          type: 'success',
          title: this.$t('notifications.update.updatedTitle'),
          timer: 2500
        })
        this.$emit('input', 1)
        this.closeModal()
      })
        .catch(error => {
          if (error.response.status === 400) {
            let text = error.response.data['hydra:description']
            // for (let i in error.response.data['hydra:description']) {
            //   text += error.response.data['hydra:description'][i] + '\n'
            // }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    handleFileUpload () {
      this.avatar = this.$refs.file.files[0]
    },
    resetData () {
      this.userData = null
      this.avatar = ''
      this.avatarPreview = null
    }
  }
}
</script>
